import type { CampaignStatus, CreateCampaignGroupInput } from '~/types/graphql';

import { CAMPAIGN_PRIORITY, DEFAULT_SETTING_TARGET, CAMPAIGN_STATUS } from '~/constants/campaign';
export * from './toast-message';
export * from './slider';

export const CAMPAIGN_GROUP_PRESET: Pick<
  CreateCampaignGroupInput,
  | 'targetChannels'
  | 'targetDevices'
  | 'targetVisitorTypes'
  | 'status'
  | 'priority'
  | 'targetCountries'
  | 'trafficRate'
> = {
  trafficRate: 0.5,
  status: CAMPAIGN_STATUS.DRAFT,
  priority: CAMPAIGN_PRIORITY.CONVERSION,
  targetDevices: DEFAULT_SETTING_TARGET,
  targetChannels: DEFAULT_SETTING_TARGET,
  targetVisitorTypes: DEFAULT_SETTING_TARGET,
  targetCountries: DEFAULT_SETTING_TARGET,
};

export enum IDisabledEditingKey {
  ADD_TEMPLATE = 'ADD_TEMPLATE',
  REMOVE_CAMPAIGN = 'REMOVE_CAMPAIGN',
  CHANGE_PAGE = 'CHANGE_PAGE',
  REMOVE_TEMPLATE = 'REMOVE_TEMPLATE',
  CHANGE_TEMPLATE = 'CHANGE_TEMPLATE',
  EDIT_TEMPLATE = 'EDIT_TEMPLATE',
}

type IDisabledEditingContent = Record<IDisabledEditingKey, string>;
type IDisabledEditing = Record<CampaignStatus, IDisabledEditingContent | null>;

export const DATA_DISABLE_EDITING: IDisabledEditing = {
  RUNNING: {
    [IDisabledEditingKey.ADD_TEMPLATE]: 'Pause experiment to add template',
    [IDisabledEditingKey.REMOVE_CAMPAIGN]: 'Pause experiment to remove',
    [IDisabledEditingKey.REMOVE_TEMPLATE]: 'Pause experiment to remove template',
    [IDisabledEditingKey.CHANGE_PAGE]: 'Pause experiment to change',
    [IDisabledEditingKey.CHANGE_TEMPLATE]: 'Pause experiment to change template',
    [IDisabledEditingKey.EDIT_TEMPLATE]: 'Pause experiment to edit template',
  },
  STOPPED: null,
  COMPLETED: null,
  DRAFT: null,
  PAUSED: null,
};
